import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import BaseLayout from 'src/sideBar/BaseLayout';
import SidebarLayout from 'src/sideBar/SidebarLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Overview = Loader(lazy(() => import('src/content/login')));

const UserSettings = Loader(
  lazy(() => import('src/content/Register'))
);

const Organization = Loader(
  lazy(() => import('src/content/Configuration/Organization'))
);
const Branch = Loader(
  lazy(() => import('src/content/Configuration/Branch'))
);
const UserRole = Loader(
  lazy(() => import('src/content/Configuration/UserRole'))
);
const Entity = Loader(
  lazy(() => import('src/content/Configuration/Entity'))
);
const Regional = Loader(
  lazy(() => import('src/content/Configuration/Regional'))
);
const Category = Loader(
  lazy(() => import('src/content/Configuration/Category'))
);
const Application = Loader(
  lazy(() => import('src/content/Configuration/Application'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '',
        element: <Overview />
      },
      {
        path: 'overview',
        element: <Navigate to="" replace />
      }
    ]
  },
  // {
  //   path: 'dashboards',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="crypto" replace />
  //     },
  //     {
  //       path: 'crypto',
  //       element: <UserSettings />
  //     }
  //   ]
  // },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: 'profile',
        children: [
          {
            path: 'Registration',
            element: <UserSettings />
          }
        ]
      },
      {
        path: 'Configuration',
        children: [
          {
            path: '',
            element: <Navigate to="Region" replace />
          },
          {
            path: 'Region',
            element: <Regional />
          },
          {
            path: 'Branch',
            element: <Branch />
          },
          {
            path: 'UserRole',
            element: <UserRole />
          },
          {
            path: 'Entity',
            element: <Entity />
          },
          {
            path: 'Application',
            element: <Application />
          },
          {
            path: 'Category',
            element: <Category />
          },
          {
            path: 'Organization',
            element: <Organization />
          }
        ]
      }
    ]
  }
];

export default routes;
